/* eslint-disable */
import React, { useState, useEffect } from 'react'
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { EditPageHeader } from '../../components/EditPageHeader';
import { Checkbox } from "@progress/kendo-react-inputs";
import * as API from "../../framework/API/api"
import { CHANNEL_RESOLUTION, DAY_START_TIMES, ENTITYNAME, EPG_FILE_TYPE, EPG_IMPORT_TYPE, L2V_TRANS_END_OFFSET_TYPE, LOGEVENT, MODULE, PROTOTYPETRIGGERTYPE, PUBLISH_REPORT_CONFIG, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from '../../framework/utility/utilityProvider';
import { useTranslation } from '../../locale/useTranslation';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import RoundButton from '../../framework/forms/helpercomponents/buttons/RoundButton';
import OttAssetCollectionSelection from '../../framework/OTT/OttAssetCollectionSelection';
import BossDialog from '../../components/BossDialog';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import CollectionSelection from '../../framework/forms/CollectionSelection';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { ConfirmDeleteAlert } from '../../ConfirmAlert';
import DeleteRoundButton from '../../framework/forms/helpercomponents/buttons/DeleteRoundButton';
import TooltipInfoCard from '../../components/TooltipInfoCard';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import ChannelPublishEpgConfigEditForm from './ChannelPublishEpgConfigEditForm';
import MyMultiSelect from '../../components/MyMultiSelect';
import ToastNotification from '../../components/ToastNotification';

const ChannelEditForm = (props) => {

    const [automation, setAutomation] = useState([]);
    const [timeZones, setTimeZones] = useState([]);
    const lang = useTranslation();

    const blankDataItem = {
        ...props.item,
        FullChannelName: props.item.copy ? "Copy of " + props.item.FullChannelName : props.item.FullChannelName ?? "",
        ShortChannelName: props.item.ShortChannelName ?? "",
        EPGCode: props.item.EPGCode ?? "",
        AsRunCode: props.item.AsRunCode ?? "",
        AutomationChannelName: props.item.AutomationChannelName ?? "",
        DayStartTime: props.item.DayStartTime ? DAY_START_TIMES.find((x) => x.value == props.item.DayStartTime) : DAY_START_TIMES[0],
        Color: props.item.Color ?? "",
        Automation: props.item.Automation ?? {},
        TimeZone: props.item.TimeZone ?? {},
        EnableAdditionalTimeZone: props.item.EnableAdditionalTimeZone ?? false,
        AdditionalTimeZone: props.item.AdditionalTimeZone ?? {},
        AsrunTimeDiff: utility.convertMilisecondsToStringWithFrames(props.item.AsrunTimeDiff) ?? '00:00:00:00',
        ExportBreaksOnly: props.item.ExportBreaksOnly ?? false,
        IsNegativeAsrunDiff: props.item.IsNegativeAsrunDiff ?? false,
        ottAsset: props.item.ottAsset ?? {},
        IsDefault: props.item.IsDefault ?? false,
        ChannelNo: props.item.ChannelNo ?? 0,
        MinGap: parseInt(props.item.MinGap) ?? 0,
        PlaylistImpBuff: props.item.PlaylistImpBuff ? utility.convertMilisecondsToStringWithFrames(props.item.PlaylistImpBuff) : "00:00:00:00",
        IsNegativePlaylistImpBuff: props.item.IsNegativePlaylistImpBuff ?? false,
        PlaylistExpBuff: props.item.PlaylistExpBuff ? utility.convertMilisecondsToStringWithFrames(props.item.PlaylistExpBuff) : "00:00:00:00",
        IsNegativePlaylistExpBuff: props.item.IsNegativePlaylistExpBuff ?? false,
        EMRC: props.item?.EMRC ?? false,
        MRCDays: props.item?.MRCDays ?? 0,
        SCTEBreakDuration: props.item?.SCTEBreakDuration ?? 4, //SAVING DEFAULT VALUE 4min
        AutoEpgImportEnabled: props?.item?.AutoEpgImportEnabled ?? false,
        FileType: props?.item?.EpgImpConfig?.FileType,
        HeaderIndex: props?.item?.EpgImpConfig?.HeaderIndex ? parseInt(props?.item?.EpgImpConfig?.HeaderIndex) : 0,
        DataIndex: props?.item?.EpgImpConfig?.DataIndex ? parseInt(props?.item?.EpgImpConfig?.DataIndex) : 0,
        InputDir: props?.item?.EpgImpConfig?.InputDir ?? "",
        Identifier: props?.item?.EpgImpConfig?.Identifier ?? "",
        OutputDir: props?.item?.EpgImpConfig?.OutputDir ?? "",
        CreateChannelDir: props?.item?.EpgImpConfig?.CreateChannelDir ?? false,
        SentToWF: props?.item?.EpgImpConfig?.SentToWF ?? false,
        EpgImportType: props?.item?.EpgImpConfig?.EpgImportType ? { _id: props?.item?.EpgImpConfig?.EpgImportType, Description: utility.getKeyByValue(EPG_IMPORT_TYPE, props?.item?.EpgImpConfig?.EpgImportType) } : {},
        IsDownloadImage: props?.item?.EpgImpConfig?.IsDownloadImage ?? false,
        ImageDir: props?.item?.EpgImpConfig?.ImageDir ?? "",
        SheetIndex: props?.item?.EpgImpConfig?.SheetIndex ? parseInt(props?.item?.EpgImpConfig?.SheetIndex) : 0,
        boxChannelNo: props?.item?.boxChannelNo,
        Resolution: props?.item?.Resolution ?? {},
        enableTimeShiftConfiguration: props?.item?.enableTimeShiftConfiguration ?? false,
        StartTriggerType: props?.item?.timeShiftConfiguration?.StartTriggerType ?? PROTOTYPETRIGGERTYPE[1],
        StartOffset: props?.item?.timeShiftConfiguration?.StartOffset ? utility.convertMilisecondsToStringWithFrames(props?.item?.timeShiftConfiguration?.StartOffset) : "00:00:00:00",
        Platforms: props?.item?.timeShiftConfiguration?.Platforms ?? [],
        AdvanceCatchupScheduleDays: props?.item?.EpgImpConfig?.AdvanceCatchupScheduleDays,
        ChannelStartDate: props?.item?.ChannelStartDate ? utility.convertMilisecondsToDateString(props?.item?.ChannelStartDate) : null,
        EnableAutoEpgExport: props?.item?.EnableAutoEpgExport ?? false,
        TransEndOffsetType: props?.item?.timeShiftConfiguration?.TransEndOffsetType ? { _id: props?.item?.timeShiftConfiguration?.TransEndOffsetType, Description: utility.getKeyByValue(L2V_TRANS_END_OFFSET_TYPE, props?.item?.timeShiftConfiguration?.TransEndOffsetType) } : null,
        TransEndOffsetValue: props?.item?.timeShiftConfiguration?.TransEndOffsetType === L2V_TRANS_END_OFFSET_TYPE.DAYS ? props?.item?.timeShiftConfiguration?.TransEndOffsetValue
            : props?.item?.timeShiftConfiguration?.TransEndOffsetType === L2V_TRANS_END_OFFSET_TYPE.FIXED ? (props?.item?.timeShiftConfiguration?.TransEndOffsetValue ? utility.convertMilisecondsToDateString(props.item.timeShiftConfiguration.TransEndOffsetValue) : null) : null,
        SCTEExcludeType: props?.item?.SCTEExcludeType ?? [],
        DefaultGenre: props?.item?.EpgImpConfig?.DefaultGenre ?? {},
        DefaultAudioTrack: props?.item?.EpgImpConfig?.DefaultAudioTrack ?? {},
        DefaultProgrammeLangId: props?.item?.EpgImpConfig?.DefaultProgrammeLangId ?? {}
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [showOttAssets, setShowOttAssets] = useState(false);
    const [linkedChannel, setLinkedChannel] = useState(false);
    const [gridDataLinkedChannels, setGridDataLinkedChannels] = useState(props.item.LinkedChannels ?? []);
    const [fileTypes, setFileTypes] = useState([]);
    const [epgImportTypes, setEpgImportTypes] = useState([]);
    const [tabNumber, setTabNumber] = React.useState(props?.tabNumber ?? "1");
    const [publishData, setPublishData] = useState(props?.item?.Publish ?? [])
    const [resolutions, setResolutions] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [transEndOffsetTypes, setTransEndOffsetTypes] = useState([]);
    const [mediaCategoryTypes, setMediaCategoryTypes] = useState([]);
    const [defaultGenres, setDefaultGenres] = useState([]);
    const [languages, setLanguages] = useState([])

    const handleTabChange = (event, newValue) => {
        setTabNumber(`${newValue}`);
    };

    useEffect(() => {
        loadcombo();
    }, [])

    const loadcombo = async () => {
        const automationRes = await API.getDataLookup(ENTITYNAME.Automation, { sort: { Name: 1 } });
        setAutomation(automationRes.data);
        const timeZoneRes = await API.getDataLookup(ENTITYNAME.TimeZone);
        setTimeZones(timeZoneRes.data);
        const fileTypeRes = Object.keys(EPG_FILE_TYPE).map((x) => {
            return {
                _id: EPG_FILE_TYPE[x],
                Description: x
            }
        })
        setFileTypes(fileTypeRes);
        const epgImportTypeRes = Object.keys(EPG_IMPORT_TYPE).map((x) => {
            return {
                _id: EPG_IMPORT_TYPE[x],
                Description: x
            }
        })
        setEpgImportTypes(epgImportTypeRes);

        const resolutionRes = Object.keys(CHANNEL_RESOLUTION).map((x) => {
            return {
                _id: CHANNEL_RESOLUTION[x],
                Description: x
            }
        })
        setResolutions(resolutionRes);
        const platformRes = await API.getDataLookup(ENTITYNAME.Platform, { query: ["Archive", "!=", true] });
        setPlatforms(platformRes.data);
        const transEndOffsetTypeRes = Object.keys(L2V_TRANS_END_OFFSET_TYPE).map((x) => {
            return {
                _id: L2V_TRANS_END_OFFSET_TYPE[x],
                Description: x
            }
        })
        setTransEndOffsetTypes(transEndOffsetTypeRes);

        const mediaCategoryTypeRes = await API.getDataLookup(ENTITYNAME.MediaCategoryType, { sort: { Description: 1 } });
        setMediaCategoryTypes(mediaCategoryTypeRes.data);

        const defaultGenreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setDefaultGenres(defaultGenreRes.data);

        const languageRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { Description: 1 } });
        setLanguages(languageRes.data);

        let gmtTimeZone = timeZoneRes.data.find(x => x.Description === "GMT") ?? {}

        if (props.item.SID > 0) {
            setDataItem({
                ...props.item,
                FullChannelName: props.item.copy ? "Copy of " + props.item.FullChannelName : props.item.FullChannelName ?? "",
                ShortChannelName: props.item.ShortChannelName ?? "",
                EPGCode: props.item.EPGCode ?? "",
                AsRunCode: props.item.AsRunCode ?? "",
                AutomationChannelName: props.item.AutomationChannelName ?? "",
                DayStartTime: props.item.DayStartTime ? DAY_START_TIMES.find((x) => x.value == props.item.DayStartTime) : DAY_START_TIMES[0],
                Color: props.item.Color ?? "",
                Automation: props.item.Automation ?? {},
                TimeZone: props.item.TimeZone ?? gmtTimeZone,
                EnableAdditionalTimeZone: props.item.EnableAdditionalTimeZone ?? false,
                AdditionalTimeZone: props.item.AdditionalTimeZone ?? {},
                AsrunTimeDiff: utility.convertMilisecondsToStringWithFrames(props.item.AsrunTimeDiff) ?? '00:00:00:00',
                ExportBreaksOnly: props.item.ExportBreaksOnly ?? false,
                IsNegativeAsrunDiff: props.item.IsNegativeAsrunDiff ?? false,
                ottAsset: props.item.ottAsset ?? {},
                IsDefault: props.item.IsDefault ?? false,
                ChannelNo: props.item.ChannelNo ?? 0,
                MinGap: parseInt(props.item.MinGap) ?? 0,
                PlaylistImpBuff: props.item.PlaylistImpBuff ? utility.convertMilisecondsToStringWithFrames(props.item.PlaylistImpBuff) : "00:00:00:00",
                IsNegativePlaylistImpBuff: props.item.IsNegativePlaylistImpBuff ?? false,
                PlaylistExpBuff: props.item.PlaylistExpBuff ? utility.convertMilisecondsToStringWithFrames(props.item.PlaylistExpBuff) : "00:00:00:00",
                IsNegativePlaylistExpBuff: props.item.IsNegativePlaylistExpBuff ?? false,
                EMRC: props.item?.EMRC ?? false,
                MRCDays: props.item?.MRCDays ?? 0,
                AutoEpgImportEnabled: props?.item?.AutoEpgImportEnabled ?? false,
                FileType: props?.item?.EpgImpConfig?.FileType,
                HeaderIndex: props?.item?.EpgImpConfig?.HeaderIndex ? parseInt(props?.item?.EpgImpConfig?.HeaderIndex) : 0,
                DataIndex: props?.item?.EpgImpConfig?.DataIndex ? parseInt(props?.item?.EpgImpConfig?.DataIndex) : 0,
                InputDir: props?.item?.EpgImpConfig?.InputDir ?? "",
                Identifier: props?.item?.EpgImpConfig?.Identifier ?? "",
                OutputDir: props?.item?.EpgImpConfig?.OutputDir ?? "",
                CreateChannelDir: props?.item?.EpgImpConfig?.CreateChannelDir ?? false,
                SentToWF: props?.item?.EpgImpConfig?.SentToWF ?? false,
                EpgImportType: props?.item?.EpgImpConfig?.EpgImportType ? { _id: props?.item?.EpgImpConfig?.EpgImportType, Description: utility.getKeyByValue(EPG_IMPORT_TYPE, props?.item?.EpgImpConfig?.EpgImportType) } : {},
                IsDownloadImage: props?.item?.EpgImpConfig?.IsDownloadImage ?? false,
                ImageDir: props?.item?.EpgImpConfig?.ImageDir ?? "",
                SheetIndex: props?.item?.EpgImpConfig?.SheetIndex ? parseInt(props?.item?.EpgImpConfig?.SheetIndex) : 0,
                boxChannelNo: props?.item?.boxChannelNo,
                Resolution: props?.item?.Resolution ?? {},
                enableTimeShiftConfiguration: props?.item?.enableTimeShiftConfiguration ?? false,
                StartTriggerType: props?.item?.timeShiftConfiguration?.StartTriggerType ?? PROTOTYPETRIGGERTYPE[1],
                StartOffset: props?.item?.timeShiftConfiguration?.StartOffset ? utility.convertMilisecondsToStringWithFrames(props?.item?.timeShiftConfiguration?.StartOffset) : "00:00:00:00",
                Platforms: props?.item?.timeShiftConfiguration?.Platforms ?? [],
                AdvanceCatchupScheduleDays: props?.item?.EpgImpConfig?.AdvanceCatchupScheduleDays,
                ChannelStartDate: props?.item?.ChannelStartDate ? utility.convertMilisecondsToDateString(props.item.ChannelStartDate) : null,
                EnableAutoEpgExport: props?.item?.EnableAutoEpgExport ?? false,
                TransEndOffsetType: props?.item?.timeShiftConfiguration?.TransEndOffsetType ? { _id: props?.item?.timeShiftConfiguration?.TransEndOffsetType, Description: utility.getKeyByValue(L2V_TRANS_END_OFFSET_TYPE, props?.item?.timeShiftConfiguration?.TransEndOffsetType) } : null,
                TransEndOffsetValue: props?.item?.timeShiftConfiguration?.TransEndOffsetType === L2V_TRANS_END_OFFSET_TYPE.DAYS ? props?.item?.timeShiftConfiguration?.TransEndOffsetValue
                    : props?.item?.timeShiftConfiguration?.TransEndOffsetType === L2V_TRANS_END_OFFSET_TYPE.FIXED ? (props?.item?.timeShiftConfiguration?.TransEndOffsetValue ? utility.convertMilisecondsToDateString(props.item.timeShiftConfiguration.TransEndOffsetValue) : null) : null,
                SCTEExcludeType: props?.item?.SCTEExcludeType ?? [],
                DefaultGenre: props?.item?.EpgImpConfig?.DefaultGenre ?? {},
                DefaultAudioTrack: props?.item?.EpgImpConfig?.DefaultAudioTrack ?? {},
                DefaultProgrammeLangId: props?.item?.EpgImpConfig?.DefaultProgrammeLangId ?? {}
            })
        }
    }

    const onChangeForm = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value });
    }

    const isValid = () => {
        if (dataItem.FullChannelName == "" || dataItem.FullChannelName == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_full_Channel_name_error_message });
            return false;
        }
        if (dataItem.ShortChannelName == "" || dataItem.ShortChannelName == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_short_Channel_name_error_message });
            return false;
        }
        if (dataItem.EPGCode == "" || dataItem.EPGCode == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_epg_code_error_message });
            return false;
        }
        if (dataItem.AutomationChannelName == "" || dataItem.AutomationChannelName == undefined) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_automation_channel_name_error_message });
            return false;
        }
        if (Object.keys(dataItem.Automation).length == 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_automation_error_message });
            return false;
        }
        if (dataItem.MinGap == undefined || isNaN(parseInt(dataItem.MinGap))) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.min_gap_invalid_error_message });
            return false;
        }
        if (parseInt(dataItem.MinGap) < 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.min_gap_error_message });
            return false;
        }
        if (dataItem.EMRC && (!dataItem.MRCDays || dataItem.MRCDays < 0 || dataItem.MRCDays > 10)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.mrc_days_valid_error_message });
            return false
        }
        return true;
    }

    const handleSubmit = async () => {
        if (isValid()) {
            const saveData = {
                _id: dataItem._id,
                SID: dataItem.SID ?? 0,
                ShortChannelName: dataItem.ShortChannelName,
                FullChannelName: dataItem.FullChannelName,
                EPGCode: dataItem.EPGCode,
                AsRunCode: dataItem.AsRunCode,
                ChannelStartDate: dataItem.ChannelStartDate ? utility.convertStringDatetoMilliseconds(dataItem.ChannelStartDate) : null,
                EnableAutoEpgExport: dataItem.EnableAutoEpgExport ?? false,
                AutomationChannelName: dataItem.AutomationChannelName,
                TimeZone: dataItem.TimeZone,
                EnableAdditionalTimeZone: dataItem.EnableAdditionalTimeZone ?? false,
                AdditionalTimeZone: dataItem.EnableAdditionalTimeZone ? dataItem.AdditionalTimeZone : {},
                DayStartTime: typeof dataItem.DayStartTime === 'object' ? dataItem.DayStartTime.value : dataItem.DayStartTime ?? 0,
                Color: dataItem.Color,
                Automation: {
                    _id: dataItem.Automation._id,
                    SID: dataItem.Automation.SID,
                    Name: dataItem.Automation.Name
                },
                isCheckListMandatory: dataItem.isCheckListMandatory ?? false,
                ExportBreaksOnly: dataItem.ExportBreaksOnly ?? false,
                AsrunTimeDiff: utility.convertStringWithFramesToMilliseconds(dataItem.AsrunTimeDiff),
                MinGap: dataItem.MinGap ?? 0,
                IsNegativeAsrunDiff: dataItem.IsNegativeAsrunDiff ?? false,
                PlaylistImpBuff: utility.convertStringWithFramesToMilliseconds(dataItem.PlaylistImpBuff),
                IsNegativePlaylistImpBuff: dataItem.IsNegativePlaylistImpBuff ?? false,
                PlaylistExpBuff: utility.convertStringWithFramesToMilliseconds(dataItem.PlaylistExpBuff),
                IsNegativePlaylistExpBuff: dataItem.IsNegativePlaylistExpBuff ?? false,
                ottAsset: {
                    _id: dataItem.ottAsset._id,
                    SID: dataItem.ottAsset.SID,
                    Title: dataItem.ottAsset.Title
                },
                IsOttEnabled: dataItem.IsOttEnabled ?? false,
                Archive: dataItem.Archive ?? false,
                IsDefault: dataItem.IsDefault ?? false,
                ChannelNo: parseInt(dataItem.ChannelNo) ?? 0,
                EnableSuffix: dataItem?.EnableSuffix ?? false,
                Suffix: dataItem?.EnableSuffix ? dataItem.Suffix ?? "" : "",
                EMRC: dataItem?.EMRC ?? false,
                MRCDays: dataItem?.MRCDays ? parseInt(dataItem?.MRCDays) : 0,
                SCTEBreakDuration: dataItem?.SCTEBreakDuration ? dataItem?.SCTEBreakDuration : 4,
                checkDuplicate: true,
                query: [["FullChannelName", "=", dataItem.FullChannelName]],
                LinkedChannels: gridDataLinkedChannels.length > 0 ? gridDataLinkedChannels.map((x) => {
                    return {
                        _id: x._id,
                        SID: x.SID,
                        FullChannelName: x.FullChannelName
                    }
                }) : [],
                AutoEpgImportEnabled: dataItem?.AutoEpgImportEnabled ?? false,
                EpgImpConfig: {
                    FileType: dataItem?.FileType && Object.keys(dataItem?.FileType).length > 0 ? {
                        _id: dataItem?.FileType?._id,
                        Description: dataItem?.FileType?.Description
                    } : {},
                    HeaderIndex: dataItem?.HeaderIndex ? parseInt(dataItem?.HeaderIndex) : 0,
                    DataIndex: dataItem?.DataIndex ? parseInt(dataItem?.DataIndex) : 0,
                    InputDir: dataItem?.InputDir ?? "",
                    Identifier: dataItem?.Identifier ?? "",
                    OutputDir: dataItem?.OutputDir ?? "",
                    CreateChannelDir: dataItem?.CreateChannelDir ?? false,
                    SentToWF: dataItem?.SentToWF ?? false,
                    EpgImportType: dataItem?.EpgImportType?._id,
                    IsDownloadImage: dataItem?.IsDownloadImage ?? false,
                    ImageDir: dataItem?.ImageDir ?? "",
                    SheetIndex: dataItem?.SheetIndex ? parseInt(dataItem?.SheetIndex) : 0,
                    AdvanceCatchupScheduleDays: dataItem?.AdvanceCatchupScheduleDays ? parseInt(dataItem?.AdvanceCatchupScheduleDays) : 0,
                    DefaultGenre: dataItem?.DefaultGenre && Object.keys(dataItem?.DefaultGenre).length > 0 ? {
                        _id: dataItem?.DefaultGenre?._id,
                        Description: dataItem?.DefaultGenre?.Description
                    } : {},
                    DefaultAudioTrack: dataItem?.DefaultAudioTrack && Object.keys(dataItem?.DefaultAudioTrack).length > 0 ? {
                        _id: dataItem?.DefaultAudioTrack?._id,
                        Description: dataItem?.DefaultAudioTrack?.Description,
                        ISOCode: dataItem?.DefaultAudioTrack?.ISOCode,
                    } : {},
                    DefaultProgrammeLangId: dataItem?.DefaultProgrammeLangId && Object.keys(dataItem?.DefaultProgrammeLangId).length > 0 ? {
                        _id: dataItem?.DefaultProgrammeLangId?._id,
                        Description: dataItem?.DefaultProgrammeLangId?.Description,
                        ISOCode: dataItem?.DefaultProgrammeLangId?.ISOCode,
                    } : {},
                },
                boxChannelNo: dataItem?.boxChannelNo ? parseInt(dataItem?.boxChannelNo) : 0,
                Resolution: dataItem?.Resolution && Object.keys(dataItem?.Resolution)?.length > 0 ? {
                    _id: dataItem?.Resolution?._id,
                    Description: dataItem?.Resolution?.Description
                } : {},
                Publish: publishData,
                enableTimeShiftConfiguration: dataItem?.enableTimeShiftConfiguration ?? false,
                timeShiftConfiguration: {
                    StartTriggerType: { ID: dataItem.StartTriggerType.ID, Description: dataItem.StartTriggerType.Description },
                    StartOffset: utility.convertStringWithFramesToMilliseconds(dataItem.StartOffset),
                    Platforms: dataItem?.Platforms.length > 0 ? dataItem?.Platforms?.map((x) => ({
                        _id: x?._id,
                        Description: x?.Description
                    })) : [],
                    TransEndOffsetType: dataItem?.TransEndOffsetType?._id,
                    TransEndOffsetValue: dataItem?.TransEndOffsetType?._id === L2V_TRANS_END_OFFSET_TYPE.DAYS ? parseInt(dataItem?.TransEndOffsetValue)
                        : dataItem?.TransEndOffsetType?._id === L2V_TRANS_END_OFFSET_TYPE.FIXED ? utility.convertStringDatetoMilliseconds(dataItem?.TransEndOffsetValue) : null
                },
                SCTEExcludeType: dataItem?.SCTEExcludeType.length > 0 ? dataItem?.SCTEExcludeType?.map((x) => ({
                    _id: x?._id,
                    SID: x?.SID,
                    Description: x?.Description
                })) : [],
            }
            console.log(saveData);
            let res = await API.saveData(ENTITYNAME.Channel, saveData);
            console.log(res);
            if (res.success) {
                let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.CHANNEL, data: res.data, message: res.message };
                API.SaveLogs(logData);
                utility.deleteLocalStorageItem(ENTITYNAME.Channel);

                await API.getDataLookup(ENTITYNAME.Channel);
                props.refresh();
                props.cancelEdit();
            }
            else {
                ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
            }
        }
    }

    const cancelEdit = () => {
        props.cancelEdit();
    }

    const handleSelectedAssets = (data) => {
        setDataItem({ ...dataItem, ottAsset: data[0] });
        setShowOttAssets(false);
    }

    const deleteLinkedChannel = (dataItem) => {
        setGridDataLinkedChannels(gridDataLinkedChannels.filter((obj) => dataItem._id != obj._id));
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.delete_successfully_grid_data_success_toast_message });
    }

    const MyCommandCellLinkedChannel = (props) => (
        <td style={{ padding: "3px" }}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteLinkedChannel(props.dataItem), () => { })} />
        </td>
    )
    const handleGridLinkedChannel = (dataList) => {
        let newData = utility.checkDuplicateInData(dataList, gridDataLinkedChannels, "FullChannelName")
        setGridDataLinkedChannels([...gridDataLinkedChannels, ...newData]);
    }

    const onSavePublishData = (dataList) => {
        console.log(dataList)
        setPublishData(dataList);
    }

    return (
        <BossDialog title={props.item.FullChannelName} onClose={cancelEdit} width="60vw">
            <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
            <Form
                onSubmit={handleSubmit}
                initialValues={dataItem}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className="row" style={{ margin: "0px", minHeight: "55vh" }}>
                            <Box sx={{ width: '100%', typography: 'body1' }}>
                                <TabContext value={tabNumber}>
                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                        <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                                            <Tab label={lang.general_label} value="1" />
                                            <Tab label={lang.epg_import_label} value="2" />
                                            <Tab label={lang.epg_publish_label} value="3" />
                                            <Tab label={lang.channel_groups_label} value="4" />
                                            <Tab label={lang.secondary_event_label} value="5" />
                                        </TabList>
                                    </Box>
                                    <TabPanel value={"1"} sx={{ minHeight: "55vh" }}>
                                        <div className='row'>
                                            <div className="col-12">
                                                <div className='row'>
                                                    <div className='col-6'>
                                                        <label>{lang.full_channel_name_label} *</label>
                                                        <input
                                                            name={"FullChannelName"}
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.FullChannelName}
                                                        />
                                                    </div>
                                                    <div className='col-6'>
                                                        <label>{lang.short_channel_name_label} *</label>
                                                        <input
                                                            name={"ShortChannelName"}
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.ShortChannelName}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-3'>
                                                        <label>{lang.epg_code_label} *</label>
                                                        <input
                                                            name={"EPGCode"}
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.EPGCode}
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <label>{lang.as_run_code_label}</label>
                                                        <input
                                                            name={"AsRunCode"}
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.AsRunCode}
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <label>{lang.channel_start_date_label}</label>
                                                        <input type="date" className="form-control form-control-sm" name="ChannelStartDate" value={dataItem.ChannelStartDate} onChange={onChangeForm} />
                                                    </div>
                                                    <div className="col-3 mt-4">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"EnableAutoEpgExport"}
                                                            component={Checkbox}
                                                            label={lang.enable_auto_epg_export_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-3'>
                                                        <label>{lang.automation_channel_name_label} *</label>
                                                        <input
                                                            name={"AutomationChannelName"}
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.AutomationChannelName}
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <label>{lang.day_Start_time_label} *</label>
                                                        <DropDownList
                                                            data={DAY_START_TIMES}
                                                            value={dataItem.DayStartTime}
                                                            name={"DayStartTime"}
                                                            textField='Description'
                                                            dataItemKey="value"
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className='col-2'>
                                                        <label>{lang.ch_number_label}</label>
                                                        <input
                                                            name={"ChannelNo"}
                                                            type="number"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.ChannelNo}
                                                        />
                                                    </div>
                                                    <div className='col-1'>
                                                        <label>{lang.color_label}</label>
                                                        <input
                                                            name={"Color"}
                                                            type="color"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.Color}
                                                        />
                                                    </div>
                                                    <div className='col'>
                                                        <label>{lang.channel_suffix_label}</label>
                                                        <div className='d-flex'>
                                                            <Field
                                                                style={{ borderColor: "black", marginTop: "8px" }}
                                                                name={"EnableSuffix"}
                                                                component={Checkbox}
                                                                label={lang.EnableSuffix}
                                                                onChange={onChangeForm}
                                                            />
                                                            <input
                                                                name={"Suffix"}
                                                                type="text"
                                                                className='form-control form-control-sm ml-3'
                                                                onChange={onChangeForm}
                                                                value={dataItem.Suffix}
                                                                disabled={!dataItem.EnableSuffix}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-3'>
                                                        <label>{lang.automation_label} *</label>
                                                        <DropDownList
                                                            data={automation}
                                                            name="Automation"
                                                            textField="Name"
                                                            dataItemKey="_id"
                                                            value={dataItem.Automation}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <label>{lang.scte_break_duration_label}</label>
                                                        <input
                                                            name={"SCTEBreakDuration"}
                                                            type="number"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.SCTEBreakDuration}
                                                            min={0}
                                                        />
                                                    </div>
                                                    <div className="col-3">
                                                        <label htmlFor="">{'Asrun Time Difference'}</label>
                                                        <TimePickerWithFormat
                                                            className="form-control form-control-sm"
                                                            name="AsrunTimeDiff"
                                                            value={dataItem.AsrunTimeDiff}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <label>{lang.minimum_gap_label}</label>
                                                        <input
                                                            className='form-control form-control-sm'
                                                            name="MinGap"
                                                            type="number"
                                                            onChange={onChangeForm}
                                                            value={dataItem.MinGap}
                                                            min={0}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-2'>
                                                    <div className='col-6'>
                                                        <label>{lang.timezone_label} *</label>
                                                        <DropDownList
                                                            data={timeZones}
                                                            name="TimeZone"
                                                            textField="Description"
                                                            dataItemKey="_id"
                                                            value={dataItem.TimeZone}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className='col-3 mt-4'>
                                                        <Field
                                                            name={"EnableAdditionalTimeZone"}
                                                            component={Checkbox}
                                                            style={{ borderColor: "black" }}
                                                            label={lang.enable_additional_timezone_label}
                                                            onChange={onChangeForm}
                                                        />
                                                        {/* <Checkbox
                                                            name={"EnableAdditionalTimeZone"}
                                                            label={lang.enable_additional_timezone_label}
                                                            value={dataItem.EnableAdditionalTimeZone}
                                                            onChange={onChangeForm}
                                                        /> */}
                                                    </div>
                                                    {dataItem.EnableAdditionalTimeZone && <div className="col-3">
                                                        <label htmlFor="TabView"> {lang.addition_timezone_label} : </label>
                                                        <DropDownList
                                                            data={timeZones}
                                                            name="AdditionalTimeZone"
                                                            textField="Description"
                                                            dataItemKey="_id"
                                                            value={dataItem.AdditionalTimeZone}
                                                            onChange={onChangeForm}
                                                            validator={(value) => value ? "" : "Please select the value"}
                                                        />
                                                    </div>}
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col-3">
                                                        <label htmlFor="">{lang.playlist_import_buffer_label}</label>
                                                        <TimePickerWithFormat
                                                            className="form-control form-control-sm"
                                                            name="PlaylistImpBuff"
                                                            value={dataItem.PlaylistImpBuff}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className="col-3 mt-3">
                                                        <Field
                                                            name={"IsNegativePlaylistImpBuff"}
                                                            component={Checkbox}
                                                            style={{ borderColor: "black" }}
                                                            label={lang.is_negative_playlist_import_buffer_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className="col-3">
                                                        <label htmlFor="">{lang.playlist_export_buffer_label}</label>
                                                        <TimePickerWithFormat
                                                            className="form-control form-control-sm"
                                                            name="PlaylistExpBuff"
                                                            value={dataItem.PlaylistExpBuff}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className="col-3 mt-3">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"IsNegativePlaylistExpBuff"}
                                                            component={Checkbox}
                                                            label={lang.is_negative_playlist_export_buffer_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col-6">
                                                        <div className='row'>
                                                            <div className='col-4 mt-4'>
                                                                <Field
                                                                    name={"EMRC"}
                                                                    style={{ borderColor: "black" }}
                                                                    component={Checkbox}
                                                                    label={lang.EMRC_label}
                                                                    onChange={onChangeForm}
                                                                />
                                                                <span><TooltipInfoCard message={lang.EMRC_tooltip_msg} /></span>
                                                            </div>
                                                            <div className='col'>
                                                                <label>{lang.MRC_days_label}</label>
                                                                <input
                                                                    name="MRCDays"
                                                                    type="number"
                                                                    min="0"
                                                                    max="10"
                                                                    className="form-control form-control-sm"
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.MRCDays}
                                                                    disabled={!dataItem.EMRC}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='col-3'>
                                                        <label>{lang.box_channel_number_label}</label>
                                                        <input
                                                            name="boxChannelNo"
                                                            type="number"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.boxChannelNo}
                                                        />
                                                    </div>
                                                    <div className='col-3'>
                                                        <label htmlFor="TabView"> {lang.resolution_label}</label>
                                                        <DropDownList
                                                            data={resolutions}
                                                            name="Resolution"
                                                            textField="Description"
                                                            dataItemKey="_id"
                                                            value={dataItem.Resolution}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                                <div className='row mt-3'>
                                                    <div className="col">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"IsOttEnabled"}
                                                            component={Checkbox}
                                                            label={lang.ott_enabled_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                                {dataItem.IsOttEnabled && <div className='row mt-2'>
                                                    <div className='col-10'>
                                                        <label>{lang.ott_assets_label}</label>
                                                        <input
                                                            name={"ottAsset"}
                                                            type="text"
                                                            className='form-control form-control-sm'
                                                            onChange={onChangeForm}
                                                            value={dataItem.ottAsset.Title ?? ""}
                                                            disabled
                                                        />
                                                    </div>
                                                    <div className='col' style={{ marginLeft: "-12px", marginTop: "20px" }}>
                                                        <RoundButton icon="ellipsis-h" btnColor="success" style={{ color: "white" }} title={lang.select_ott_assets_header_dialog} onClick={() => setShowOttAssets(true)} />
                                                        <RoundButton icon="trash" btnColor="danger" style={{ color: "white", marginLeft: '5px' }} title={lang.delete_all_button_tooltip} onClick={() => setDataItem({ ...dataItem, ottAsset: {} })} />
                                                    </div>
                                                </div>}
                                                <div className='row mt-3'>
                                                    <div className="col-3">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"Archive"}
                                                            component={Checkbox}
                                                            label={lang.archive}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className="col-3 px-0">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"ExportBreaksOnly"}
                                                            component={Checkbox}
                                                            label={lang.ExportBreaksOnly}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className="col-3 px-0">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"IsNegativeAsrunDiff"}
                                                            component={Checkbox}
                                                            label={lang.is_negative_asrun_diff_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                    <div className="col px-0">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"IsDefault"}
                                                            component={Checkbox}
                                                            label={lang.is_default_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={"2"} sx={{ minHeight: "55vh" }}>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div className='row'>
                                                    <div className="col">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"AutoEpgImportEnabled"}
                                                            component={Checkbox}
                                                            label={lang.auto_epg_import_enabled_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                                {dataItem.AutoEpgImportEnabled &&
                                                    <div className="mt-2" style={{ width: "53vw", minHeight: "auto", border: '1px solid #ccc', borderRadius: '5px!important' }}>
                                                        <div style={{ position: "relative", fontWeight: "500", fontSize: "12px", top: "-0.8em", marginLeft: "0.8em", display: "inline", backgroundColor: "white" }}>&nbsp; {lang.epg_import_Configuration_label} &nbsp;</div>
                                                        <div className="row" style={{ padding: "6px" }}>
                                                            <div className="col-8">
                                                                <label>{lang.input_dir_label}</label>
                                                                <input
                                                                    name="InputDir"
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.InputDir}
                                                                />
                                                            </div>
                                                            <div className="col-4">
                                                                <label>{lang.identifier_label}</label>
                                                                <input
                                                                    name="Identifier"
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.Identifier}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-1" style={{ padding: "6px" }}>
                                                            <div className="col-3">
                                                                <label htmlFor="TabView"> {lang.file_type_label} </label>
                                                                <DropDownList
                                                                    data={fileTypes}
                                                                    name="FileType"
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={dataItem.FileType}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-2">
                                                                <label>{lang.sheet_index_label}</label>
                                                                <input
                                                                    name="SheetIndex"
                                                                    type="number"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.SheetIndex}
                                                                />
                                                            </div>
                                                            <div className="col-2">
                                                                <label>{lang.header_index_label}</label>
                                                                <input
                                                                    name="HeaderIndex"
                                                                    type="number"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.HeaderIndex}
                                                                />
                                                            </div>
                                                            <div className="col-2">
                                                                <label>{lang.data_index_label}</label>
                                                                <input
                                                                    name="DataIndex"
                                                                    type="number"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.DataIndex}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label htmlFor="TabView"> {lang.epg_import_type_label} </label>
                                                                <DropDownList
                                                                    data={epgImportTypes}
                                                                    name="EpgImportType"
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={dataItem.EpgImportType}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-1" style={{ padding: "6px" }}>
                                                            <div className="col-4">
                                                                <label>{lang.output_dir_label}</label>
                                                                <input
                                                                    name="OutputDir"
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.OutputDir}
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-4">
                                                                <Field
                                                                    style={{ borderColor: "black" }}
                                                                    name={"CreateChannelDir"}
                                                                    component={Checkbox}
                                                                    label={lang.create_Channel_Dir_label}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-2 mt-4">
                                                                <Field
                                                                    style={{ borderColor: "black" }}
                                                                    name={"SentToWF"}
                                                                    component={Checkbox}
                                                                    label={lang.sent_to_wf_label}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label>{lang.advance_catchup_schedule_days_label}</label>
                                                                <input
                                                                    name="AdvanceCatchupScheduleDays"
                                                                    type="number"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.AdvanceCatchupScheduleDays}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-1" style={{ padding: "6px" }}>
                                                            <div className="col-3">
                                                                <label htmlFor="TabView"> {lang.default_genre_label} </label>
                                                                <DropDownList
                                                                    data={defaultGenres}
                                                                    name="DefaultGenre"
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={dataItem.DefaultGenre}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label htmlFor="TabView"> {lang.default_audioTrack_label} </label>
                                                                <DropDownList
                                                                    data={languages}
                                                                    name="DefaultAudioTrack"
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={dataItem.DefaultAudioTrack}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-3">
                                                                <label htmlFor="TabView"> {lang.default_programme_language_id_label} </label>
                                                                <DropDownList
                                                                    data={languages}
                                                                    name="DefaultProgrammeLangId"
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={dataItem.DefaultProgrammeLangId}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-3 mt-4">
                                                                <Field
                                                                    style={{ borderColor: "black" }}
                                                                    name={"IsDownloadImage"}
                                                                    component={Checkbox}
                                                                    label={lang.download_image_label}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            {dataItem.IsDownloadImage && <div className="col-6 mt-2">
                                                                <label>{lang.image_dir_label}</label>
                                                                <input
                                                                    name="ImageDir"
                                                                    type="text"
                                                                    className='form-control form-control-sm'
                                                                    onChange={onChangeForm}
                                                                    value={dataItem.ImageDir}

                                                                />
                                                            </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                <div className='row mt-3'>
                                                    <div className="col">
                                                        <Field
                                                            style={{ borderColor: "black" }}
                                                            name={"enableTimeShiftConfiguration"}
                                                            component={Checkbox}
                                                            label={lang.l2v_time_shift_configuration_label}
                                                            onChange={onChangeForm}
                                                        />
                                                    </div>
                                                </div>
                                                {dataItem.enableTimeShiftConfiguration &&
                                                    <div className="mt-2" style={{ width: "53vw", minHeight: "auto", border: '1px solid #ccc', borderRadius: '5px!important' }}>
                                                        <div style={{ position: "relative", fontWeight: "500", fontSize: "12px", top: "-0.8em", marginLeft: "0.8em", display: "inline", backgroundColor: "white" }}>&nbsp; {lang.time_shift_configuration_label} &nbsp;</div>
                                                        <div className="row mt-1 mb-1" style={{ padding: "6px" }}>
                                                            <div className="col-4">
                                                                <label htmlFor="TabView"> {lang.Start_trigger_type_label} </label>
                                                                <DropDownList
                                                                    style={{ backgroundColor: "white" }}
                                                                    data={PROTOTYPETRIGGERTYPE}
                                                                    name="StartTriggerType"
                                                                    textField="Description"
                                                                    dataItemKey="ID"
                                                                    defaultValue={PROTOTYPETRIGGERTYPE[1]}
                                                                    value={dataItem.StartTriggerType}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className="col-4">
                                                                <label>{lang.start_offset_label}</label>
                                                                <TimePickerWithFormat
                                                                    className="form-control form-control-sm"
                                                                    name="StartOffset"
                                                                    value={dataItem.StartOffset}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            <div className='col-4'>
                                                                <label>{lang.platform_label}</label>
                                                                <MyMultiSelect
                                                                    style={{ backgroundColor: 'white', border: '1px solid lightgrey' }}
                                                                    data={platforms}
                                                                    name="Platforms"
                                                                    dataItemKey="_id"
                                                                    textField="Description"
                                                                    value={dataItem.Platforms}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="row mt-1 mb-2" style={{ padding: "6px" }}>
                                                            <div className="col-4">
                                                                <label htmlFor="TabView"> {lang.trans_end_offset_type_label} </label>
                                                                <DropDownList
                                                                    style={{ backgroundColor: "white" }}
                                                                    data={transEndOffsetTypes}
                                                                    name="TransEndOffsetType"
                                                                    textField="Description"
                                                                    dataItemKey="_id"
                                                                    value={dataItem.TransEndOffsetType}
                                                                    onChange={onChangeForm}
                                                                />
                                                            </div>
                                                            {dataItem?.TransEndOffsetType?._id === L2V_TRANS_END_OFFSET_TYPE.DAYS &&
                                                                <div className="col-4">
                                                                    <label>{lang.trans_end_offset_value_label}</label>
                                                                    <input
                                                                        name="TransEndOffsetValue"
                                                                        type="number"
                                                                        className='form-control form-control-sm'
                                                                        onChange={onChangeForm}
                                                                        value={dataItem.TransEndOffsetValue}
                                                                    />
                                                                </div>
                                                            }
                                                            {dataItem?.TransEndOffsetType?._id === L2V_TRANS_END_OFFSET_TYPE.FIXED &&
                                                                <div className="col-4">
                                                                    <label>{lang.trans_end_offset_value_label}</label>
                                                                    <input
                                                                        name="TransEndOffsetValue"
                                                                        type="date"
                                                                        className='form-control form-control-sm'
                                                                        onChange={onChangeForm}
                                                                        value={dataItem.TransEndOffsetValue}
                                                                    />
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={"3"} sx={{ minHeight: "55vh" }}>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <ChannelPublishEpgConfigEditForm publishData={publishData} setPublishData={setPublishData} onSavePublishData={onSavePublishData} />
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={"4"} sx={{ minHeight: "55vh" }}>
                                        <div className='row'>
                                            <div className='col-12'>
                                                <div><AddRoundButton onClick={() => setLinkedChannel(true)} style={{ marginTop: "-8px", marginLeft: "5px" }} />
                                                    <span className='float-right' style={{ marginTop: "8px" }}>{lang.linked_channels_label}</span>
                                                    <Grid style={{ height: "36vh", margin: '0px 0px 4px 7px', overflow: "hidden" }} className="mt-2" data={gridDataLinkedChannels}>
                                                        <GridColumn cell={MyCommandCellLinkedChannel} width={"40px"} locked={true} />
                                                        <GridColumn field="FullChannelName" title={lang.channel_column} editable={false} />
                                                    </Grid>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                    <TabPanel value={"5"} sx={{ minHeight: "55vh" }}>
                                        <div className='row'>
                                            <div className='col-8'>
                                                <label>{lang.scte_exc_media_category_type_label}</label>
                                                <MyMultiSelect
                                                    style={{ backgroundColor: 'white', border: '1px solid lightgrey', marginTop: "2px" }}
                                                    data={mediaCategoryTypes}
                                                    name="SCTEExcludeType"
                                                    dataItemKey="_id"
                                                    textField="Description"
                                                    value={dataItem.SCTEExcludeType}
                                                    onChange={onChangeForm}
                                                    className="form-control form-control-sm"
                                                />
                                            </div>
                                        </div>
                                    </TabPanel>
                                </TabContext>
                            </Box>
                            <p className="text-muted" style={{ fontSize: "12px" }}>{lang.note_label} : {lang.make_sure_to_logout_and_login_again_to_see_the_changes_message} </p>
                        </div>
                    </FormElement>
                )}
            />
            {linkedChannel && <CollectionSelection wherestatement={["SID", "!=", dataItem.SID]} setDataList={handleGridLinkedChannel} closeForm={() => setLinkedChannel(false)} entityname={ENTITYNAME.Channel} width={"50vw"} title={lang.select_channel_collection_header} addButtonTitle={lang.select_collection_button_text} />}
            {showOttAssets && <OttAssetCollectionSelection title={lang.select_ott_assets_header_dialog} entityname={ENTITYNAME.OttAsset} closeForm={() => setShowOttAssets(false)} setDataList={handleSelectedAssets} width="60vw" mode="single" />}
        </BossDialog>
    )
}

export default ChannelEditForm;